import { IPageLayoutType } from "../../types/pageLayoutTypes";

export const useSiteLabVendorsDetails = () => {
  const rowData = [
    {
      id: "S1001",
      isNew: true,
      name: "Number One Hospital",
      country: "USA",
      city: "New York",
      type: "Site",
      studyID: "ONC-NSCLC-2024-01",
    },
    {
      id: "V1002",
      isUpdated: true,
      name: "Lab Max",
      country: "USA",
      city: "Pittsburgh",
      type: "Vendor lab",
      studyID: "ONC-NSCLC-2024-01",
    },
    {
      id: "CL1987",
      badge: "",
      name: "Lab Corp A32",
      country: "USA",
      city: "New York",
      type: "Central lab",
      studyID: "ONC-NSCLC-2024-01",
    },
    {
      id: "S10002",
      badge: "",
      name: "New Life Hospital",
      country: "USA",
      city: "New York",
      type: "Site",
      studyID: "ONC-NSCLC-2024-01",
    },
  ];
  const siteDetailsContentJson: IPageLayoutType[] = [
    {
      title: "Number One Hospital",
      caption: "S1001",
      chip: "Recruiting",
      content: [
        {
          label: "Address",
          value: "230 Clinical Drive, Suite 123, New York, NY 12345, USA",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Name",
          value: "Katie Neil",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Email",
          value: "katieneil@email.com",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Phone Number",
          value: "555-555-5555",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];
  const centralLabDetailsContentJson: IPageLayoutType[] = [
    {
      title: "Lab Corp A32",
      caption: "CL1987",
      description: "",
      content: [
        {
          label: "Address",
          value: "230 Clinical Drive, Suite 123, New York, NY 12345, USA",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Name",
          value: "Amy Hall",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Email",
          value: "amy.hall@labcorp.com",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Phone Number",
          value: "789-456-1230",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  const vendorDetailsContentJson: IPageLayoutType[] = [
    {
      title: "Lab Max",
      caption: "VL1002",
      description: "",
      content: [
        {
          label: "Address",
          value: "2999 Best Lab Drive, Suite 100, Pitsburgh, PA 20211, USA",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Name",
          value: "Katie Crise",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Email",
          value: "katie.crise@labmax.com",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Phone Number",
          value: "123-456-1230",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];
  return {
    rowData,
    siteDetailsContentJson,
    centralLabDetailsContentJson,
    vendorDetailsContentJson,
  };
};
